import React, { useEffect, useState } from "react";
import { Badge, Collapse, ListGroup } from "react-bootstrap";
import SplitPane from "react-split-pane";
import { useParams } from "react-router-dom";
import FreezeUnfreezeHistory from "./FreezeUnfreezeHistory";
import SignatureReviewHistory from "./SignatureReviewHistory";
import FieldUpdatedHistory from "./FieldUpdatedHistory";
import FieldQueryHistory from "./FieldQueryHistory";
import Swal from "sweetalert2";
import SignatureReviewAllField from "./SignatureReviewAllField";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { FaRegPlusSquare } from "react-icons/fa";
import { GoChecklist } from "react-icons/go";
import FieldErrorNotification from "./FieldErrorNotification";
import UseToggle from "../../../../Hooks/UseToggle";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import ReviewFormDataEntry from "./ReviewFormDataEntry";
import Loader from "../../../../img/Document scan.gif"
import FormDataEntryReport from "./FormDataEntryReport";

const FormDataEntry = ({ activeTabName, tableRef, onMouseDown }) => {
  const [formId, setFormId] = useState("");
  const [version, setVersion] = useState("");
  const [formFields, setFormFields] = useState([]);
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fieldLoading, setFieldLoading] = useState(false);
  const [dataEntryLoader, setDataEntryLoader] = useState(false);
  const [loadForm, setLoadForm] = useState(false);
  const [formName, setFormName] = useState("")
  const [formRepeat, setFormRepeat] = useState("")
  const [originalFormId, setOriginalFormId] = useState("")
  const [repeatNumber, setRepeatNumber] = useState(0)
  const [formType, setFormType] = useState("")
  const [entryType, setEntryType] = useState("")
  const [recordId, setRecordId] = useState("")
  const [recordNumber, setRecordNumber] = useState("")
  const [logRecordLoader, setLogRecordLoader] = useState(false)
  const [fieldLabel, setFieldLabel] = useState("")
  const [fieldId, setFieldId] = useState("")
  const [logRecord, setLogRecord] = useState([])
  const [totalDataEntry, setTotalDataEntry] = useState([])
  const [selectedFields, setSelectedFields] = useState([])
  const [selectedRadioField, setSelectedRadioField] = useState("")
  const [remark, setRemark] = useState("");
  const [querySubject, setQuerySubject] = useState("");
  const [queryMessage, setQueryMessage] = useState("");
  const [reasonMessage, setReasonMessage] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [historyLoader, setHistoryLoader] = useState(false);
  const [freezeUnfreezeHistory, setFreezeUnfreezeHistory] = useState([])
  const [dataEntryReviewHistory, setDataEntryReviewHistory] = useState([])
  const [dataEntryFormReviewHistory, setDataEntryFormReviewHistory] = useState([])
  const [dataEntryFormReviewHistoryLoader, setDataEntryFormReviewHistoryLoader] = useState(false)
  const [dataEntryQueryHistory, setDataEntryQueryHistory] = useState([])
  const [dataEntryQueryNotification, setDataEntryQueryNotification] = useState([])
  const [dataEntryQueryDiscussion, setDataEntryQueryDiscussion] = useState([])
  const [updatedFieldHistory, setUpdatedFieldHistory] = useState([])
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();
  let { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4, toggle5, setToggle5, toggle6, setToggle6, toggle7, setToggle7, toggle8, setToggle8 } = UseToggle();
  let totalOptionId = []
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  const [saveButtonLoader, setSaveButtonLoader] = useState(false);
  const [repeatButtonLoader, setRepeatButtonLoader] = useState(false);
  const [unfreezeButtonLoader, setUnfreezeButtonLoader] = useState(false);
  const [queryButtonLoader, setQueryButtonLoader] = useState(false);
  const [signedButtonLoader, setSignedButtonLoader] = useState(false);
  const [signedAllButtonLoader, setSignedAllButtonLoader] = useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [freezeLoader, setFreezeLeader] = useState(false);
  const [signButtonLoader, setSignButtonLeader] = useState(false);
  const [genarateButtonLoader, setGenerateButtonLeader] = useState(false);
  const [queryDataLoader, setQueryDataLeader] = useState(false);
  const [editField, setEditField] = useState([]);

  useEffect(() => {
    setTotalDataEntry([])
  }, [formId]);

  totalDataEntry?.forEach(item => {
    if (item && typeof item === "object") {
      if (Array.isArray(item.value)) {
        item.value.forEach(v => {
          if (v?.id) totalOptionId.push(Number(v.id));
        });
      } else if (item?.id) {
        totalOptionId.push(Number(item.id));
      }
    }
  });

  const valueRanderFunction = (id) => {
    return totalDataEntry?.find(item => item.fieldId === id) || ""
  }

  const getStudyFormListBasedonEventSchema = async () => {
    setLoading(true);
    let data = await studySiteDataEntryServices.getStudyFormListBasedonEventSchema(
      studyId,
      activeTabName?.siteId,
      activeTabName?.subjectId || "no",
      activeTabName?.schemaId,
      activeTabName?.eventId,
      activeTabName?.timePointUniqueId || "no",
      activeTabName?.type,
      activeTabName?.viewType,
      activeTabName?.repeatEventId || "no",
      activeTabName?.repeatTimePointId || "no",
      StudyMode
    );
    setFormMetadataList(data?.data || []);
    setLoading(false);
  };

  const getStudyLevelFormFieldsByVersion = async (e) => {
    setFieldLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      originalFormId,
      version
    );
    if (loadForm) {
      setFormFields(data?.data?.formFields || []);
    } else {
      setFormFields([]);
    }
    setFieldLoading(false);
  };

  useEffect(() => {
    if (activeTabName) {
      getStudyFormListBasedonEventSchema();
    }
  }, [activeTabName]);

  const getStudySubjectDataEntry = async () => {
    setDataEntryLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId || "no"
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.originalFormId = originalFormId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectDataEntry(userData)
    setTotalDataEntry(data?.data || [])
    setDataEntryLoader(false)
  }

  const getStudySubjectLogDataEntry = async () => {
    setLogRecordLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectLogDataEntry(userData)
    setLogRecord(data?.data || [])
    setTotalDataEntry([])
    setLogRecordLoader(false)
  }

  const getStudySubjectFormFieldQueryHistoryDataEntry = async (fieldId, fieldLabel) => {
    setQueryDataLeader(true)
    setToggle3()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryHistoryDataEntry(userData)
    setDataEntryQueryHistory(data?.data || [])
    setDataEntryQueryDiscussion([])
    setQueryDataLeader(false)
  }

  const getStudySubjectFormFieldQueryNotificationDataEntry = async (fieldId, fieldLabel) => {
    setToggle5()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryNotificationDataEntry(userData)
    setDataEntryQueryNotification(data?.data || [])
  }

  const getStudySubjectFormFieldQueryDiscussionDataEntry = async (queryId) => {
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.formId = formId
    userData.queryId = queryId
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldQueryDiscussionDataEntry(userData)
    setDataEntryQueryDiscussion(data?.data || [])
  }

  const getStudySubjectFormFreezeUnfreezeHistoryDataEntry = async (fieldId, fieldLabel) => {
    setFreezeLeader(true)
    setToggle()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData)
    setFreezeUnfreezeHistory(data?.data || [])
    setFreezeLeader(false)
  }

  const getStudySubjectFormFieldReviewHistoryDataEntry = async (fieldId, fieldLabel) => {
    setToggle1()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormFieldReviewHistoryDataEntry(userData)
    setDataEntryReviewHistory(data?.data || [])
  }

  const getStudyDataEntryFieldUpdatedHistoryList = async (fieldId, fieldLabel) => {
    setHistoryLoader(true)
    setToggle2()
    setFieldId(fieldId)
    setFieldLabel(fieldLabel)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudyDataEntryFieldUpdatedHistoryList(userData)
    setUpdatedFieldHistory(data?.data || [])
    setHistoryLoader(false)
  }

  useEffect(() => {
    if (formId && version) {
      getStudyLevelFormFieldsByVersion();
    }
    if (formId && version && formType && entryType) {
      getStudyLevelFormFieldsByVersion();
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
      } else if (formType === "log") {
        if (!recordId) {
          getStudySubjectLogDataEntry()
        }
        if (activeTabName?.autoForm === "yes") {
          getStudySubjectLogDataEntry()
        }
        if (recordId) {
          getStudySubjectDataEntry()
        }
      }
    }
  }, [formId, version, formType, entryType, recordId, loadForm]);

  const addNewStudySubjectDataEntry = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Submit Form Details!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Submit it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSaveButtonLoader(true)
        const filteredDataEntry = totalDataEntry?.map(obj => {
          const {
            status,
            unitStatus,
            valueRemarkStatus,
            referenceRangeLowerLimitStatus,
            referenceRangeUpperLimitStatus,
            referenceRangeIndicatorStatus,
            clinicalSignificanceStatus,
            reviewStatus,
            unitReviewStatus,
            reviewValueRemarkStatus,
            referenceRangeLowerLimitReviewStatus,
            referenceRangeUpperLimitReviewStatus,
            referenceRangeIndicatorReviewStatus,
            clinicalSignificanceReviewStatus,
            remarkReviewStatus,
            queryStatus,
            unitQueryStatus,
            queryValueRemarkStatus,
            referenceRangeLowerLimitQueryStatus,
            referenceRangeUpperLimitQueryStatus,
            referenceRangeIndicatorQueryStatus,
            clinicalSignificanceQueryStatus,
            remarkQueryStatus,
            queryNotifyStatus,
            unitQueryNotifyStatus,
            queryNotifyValueRemarkStatus,
            referenceRangeLowerLimitQueryNotifyStatus,
            referenceRangeUpperLimitQueryNotifyStatus,
            referenceRangeIndicatorQueryNotifyStatus,
            clinicalSignificanceQueryNotifyStatus,
            remarkQueryNotifyStatus,
            ...rest
          } = obj;
          return rest;
        });
        let filteredData = filteredDataEntry?.filter(obj => Object.keys(obj)?.length > 2);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.originalFormId = originalFormId
        userData.formVersion = version
        userData.formType = formType
        userData.recordId = recordId
        userData.dataEntryType = entryType
        userData.mode = StudyMode
        userData.dataEntry = filteredData
        userData.editField = editField
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.addNewStudySubjectDataEntry(userData)
        if (data?.statusCode === 200) {
          setEditField([])
          getStudyFormListBasedonEventSchema()
          getStudyLevelFormFieldsByVersion()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
            }
          }
        }
      }
      setSaveButtonLoader(false)
    });
  };

  const repeatStudySubjectEventForm = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Repeat this Form!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Repeat it!`,
    }).then(async (result) => {
      setRepeatButtonLoader(true)
      if (result.isConfirmed) {
        let userData = {}
        userData.studyId = studyId
        userData.siteId = activeTabName?.siteId
        userData.subjectId = activeTabName?.subjectId
        userData.schemaId = activeTabName?.schemaId
        userData.eventId = activeTabName?.eventId
        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId = activeTabName?.timePointUniqueId
        }
        userData.formId = formId
        userData.formVersion = version
        userData.formType = formType
        userData.dataEntryType = entryType
        userData.mode = StudyMode
        if (activeTabName?.repeatEventId) {
          userData.repeatEventId = activeTabName?.repeatEventId
        }
        if (activeTabName?.repeatTimePointId) {
          userData.repeatTimePointId = activeTabName?.repeatTimePointId
        }
        let data = await studySiteDataEntryServices.repeatStudySubjectEventForm(userData)
        if (data?.statusCode === 200) {
          getStudyFormListBasedonEventSchema()
        }
      }
      setRepeatButtonLoader(false)
    });
  };

  const unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry = async () => {
    setUnfreezeButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.remark = remark
    userData.mode = StudyMode
    userData.fieldLabelName = selectedFields
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry(userData)
    if (data?.statusCode === 200) {
      setRemark("")
      setFieldId("")
      setFieldLabel("")
      setSelectedFields([])
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
        getStudySubjectFormFreezeUnfreezeHistoryDataEntry(fieldId, fieldLabel)
      } else if (formType === "log") {
        getStudySubjectLogDataEntry()
        if (recordId) {
          getStudySubjectDataEntry()
          getStudySubjectFormFreezeUnfreezeHistoryDataEntry(fieldId, fieldLabel)
        }
      }
    }
    setUnfreezeButtonLoader(false)
  }

  const signatureStudySubjectFormReviewFieldHistoryDataEntry = async () => {
    setSignedButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.remark = remark
    userData.mode = StudyMode
    userData.fieldLabelName = selectedFields
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewFieldHistoryDataEntry(userData)
    if (data?.statusCode === 200) {
      setRemark("")
      setFieldId("")
      setFieldLabel("")
      setSelectedFields([])
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
        getStudySubjectFormFieldReviewHistoryDataEntry(fieldId, fieldLabel)
      } else if (formType === "log") {
        getStudySubjectLogDataEntry()
        if (recordId) {
          getStudySubjectDataEntry()
          getStudySubjectFormFieldReviewHistoryDataEntry(fieldId, fieldLabel)
        }
      }
    }
    setSignedButtonLoader(false)
  }

  const getStudySubjectFormReviewHistoryDataEntry = async () => {
    let userData = {}
    setDataEntryFormReviewHistoryLoader(true)
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.getStudySubjectFormReviewHistoryDataEntry(userData)
    setDataEntryFormReviewHistory(data?.data || [])
    setDataEntryFormReviewHistoryLoader(false)
  }

  const signatureStudySubjectFormReviewHistoryDataEntry = async () => {
    setSignButtonLeader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.mode = StudyMode
    userData.userId = userId
    userData.password = password
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    userData.totalForm = (formMetadataList || [])?.filter(item => item.formType === "regular")?.length
    let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewHistoryDataEntry(userData)
    if (data?.statusCode === 200) {
      getStudySubjectFormReviewHistoryDataEntry()
      getStudyFormListBasedonEventSchema()
      if (recordId) {
        getStudySubjectLogDataEntry()
      }
      setToggle6()
    }
    setSignButtonLeader(false)
  }

  const signatureStudySubjectFormReviewAllFieldDataEntry = async () => {
    setSignedAllButtonLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.remark = remark
    userData.mode = StudyMode
    userData.fieldLabelName = selectedFields
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.signatureStudySubjectFormReviewAllFieldDataEntry(userData)
    if (data?.statusCode === 200) {
      setToggle4()
      setRemark("")
      setSelectedFields([])
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
      } else if (formType === "log") {
        getStudySubjectLogDataEntry()
        if (recordId) {
          getStudySubjectDataEntry()
        }
      }
    }
    setSignedAllButtonLoader(false)
  }

  const generateManualQueryStudySubjectFormFieldDataEntry = async () => {
    setGenerateButtonLeader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = activeTabName?.siteId
    userData.subjectId = activeTabName?.subjectId
    userData.schemaId = activeTabName?.schemaId
    userData.eventId = activeTabName?.eventId
    if (activeTabName?.timePointUniqueId) {
      userData.timePointUniqueId = activeTabName?.timePointUniqueId
    }
    userData.formId = formId
    userData.formVersion = version
    userData.formType = formType
    userData.recordId = recordId
    userData.dataEntryType = entryType
    userData.fieldId = fieldId
    userData.remark = remark
    userData.mode = StudyMode
    userData.fieldLabelName = selectedRadioField
    userData.subject = querySubject
    userData.message = queryMessage
    if (activeTabName?.repeatEventId) {
      userData.repeatEventId = activeTabName?.repeatEventId
    }
    if (activeTabName?.repeatTimePointId) {
      userData.repeatTimePointId = activeTabName?.repeatTimePointId
    }
    let data = await studySiteDataEntryServices.generateManualQueryStudySubjectFormFieldDataEntry(userData)
    if (data?.statusCode === 200) {
      setQuerySubject("")
      setQueryMessage("")
      setFieldId("")
      setFieldLabel("")
      setSelectedRadioField("")
      getStudyFormListBasedonEventSchema()
      if (formType === "regular") {
        setRecordId("")
        getStudySubjectDataEntry()
        getStudySubjectFormFieldQueryHistoryDataEntry(fieldId, fieldLabel)
      } else if (formType === "log") {
        getStudySubjectLogDataEntry()
        if (recordId) {
          getStudySubjectDataEntry()
          getStudySubjectFormFieldQueryHistoryDataEntry(fieldId, fieldLabel)
        }
      }
    }
    setGenerateButtonLeader(false)
  }

  const generateManualQueryStatusStudySubjectFormField = async (queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${status === "close" ? "Close" : "Cancel"} this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "close" ? "Close" : "Cancel"} it!`,
    }).then(async (result) => {
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.schemaId = activeTabName?.schemaId
      userData.eventId = activeTabName?.eventId
      if (activeTabName?.timePointUniqueId) {
        userData.timePointUniqueId = activeTabName?.timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (activeTabName?.repeatEventId) {
        userData.repeatEventId = activeTabName?.repeatEventId
      }
      if (activeTabName?.repeatTimePointId) {
        userData.repeatTimePointId = activeTabName?.repeatTimePointId
      }
      if (status === "cancel") {
        userData.message = reasonMessage
      }
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateManualQueryStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setFieldId("")
          setFieldLabel("")
          setReasonMessage("")
          getStudyFormListBasedonEventSchema()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryHistoryDataEntry(fieldId, fieldLabel)
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryHistoryDataEntry(fieldId, fieldLabel)
            }
          }
        }
      }
    });
  }

  const generateQueryNotificationStatusStudySubjectFormField = async (queryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Close this Notification Error!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Close it!`,
    }).then(async (result) => {
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.schemaId = activeTabName?.schemaId
      userData.eventId = activeTabName?.eventId
      if (activeTabName?.timePointUniqueId) {
        userData.timePointUniqueId = activeTabName?.timePointUniqueId
      }
      userData.mode = StudyMode
      userData.formId = formId
      userData.queryId = queryId
      userData.status = status
      if (activeTabName?.repeatEventId) {
        userData.repeatEventId = activeTabName?.repeatEventId
      }
      if (activeTabName?.repeatTimePointId) {
        userData.repeatTimePointId = activeTabName?.repeatTimePointId
      }
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.generateQueryNotificationStatusStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setFieldId("")
          setFieldLabel("")
          setReasonMessage("")
          getStudyFormListBasedonEventSchema()
          if (formType === "regular") {
            setRecordId("")
            getStudySubjectDataEntry()
            getStudySubjectFormFieldQueryNotificationDataEntry(fieldId, fieldLabel)
          } else if (formType === "log") {
            getStudySubjectLogDataEntry()
            if (recordId) {
              getStudySubjectDataEntry()
              getStudySubjectFormFieldQueryNotificationDataEntry(fieldId, fieldLabel)
            }
          }
        }
      } else {
        getStudySubjectFormFieldQueryNotificationDataEntry(fieldId, fieldLabel)
      }
    });
  }

  const queryDiscussionStudySubjectFormField = async (queryId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Response this query!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Response it!`,
    }).then(async (result) => {
      setQueryButtonLoader(true)
      let userData = {}
      userData.studyId = studyId
      userData.siteId = activeTabName?.siteId
      userData.subjectId = activeTabName?.subjectId
      userData.formId = formId
      userData.queryId = queryId
      userData.type = type
      userData.message = responseMessage
      if (result.isConfirmed) {
        let data = await studySiteDataEntryServices.queryDiscussionStudySubjectFormField(userData);
        if (data?.statusCode === 200) {
          setResponseMessage("")
          getStudySubjectFormFieldQueryDiscussionDataEntry(queryId)
        }
      }
      setQueryButtonLoader(false)
    });
  }

  useEffect(() => {
    if (activeTabName?.autoForm === "yes") {
      setFormId(activeTabName?.formId)
      setFormName(activeTabName?.formName)
      setOriginalFormId(activeTabName?.formId)
      setVersion(activeTabName?.formVersion)
      setFormType(activeTabName?.formType)
      setEntryType(activeTabName?.type)
      setRecordId(activeTabName?.recordId || "")
      if (activeTabName?.formType === "log") {
        setOpenAction(activeTabName?.formId)
      }
      setLoadForm(true)
    }
    setTotalDataEntry([])
  }, [activeTabName]);

  const tempFieldCache = {};

  const handleNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber) => {
    if (type === "value") {
      let regex;
      if (wholeNumber) {
        regex = /^-?\d*$/;
      } else if (floatNumber) {
        regex = /^-?\d*(\.\d*)?$/;
      } else {
        return;
      }
      if (!regex.test(newValue)) return;
    }
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "number",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;

      if ((finalValue !== "" && finalValue != null) || (finalUnit !== "" && finalUnit != null) || (finalUnitType !== "" && finalUnitType != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomNumberChange = (fieldId, type, newValue, wholeNumber, floatNumber, disable) => {
    if (type === "value") {
      let regex;
      if (wholeNumber) {
        regex = /^-?\d*$/;
      } else if (floatNumber) {
        regex = /^-?\d*(\.\d*)?$/;
      } else {
        return;
      }
      if (!regex.test(newValue)) return;
    }

    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customNumber" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "text",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalUnit = type === "unit" ? newValue : updatedItem.unit;
      const finalUnitType = type === "unitType" ? newValue : updatedItem.unitType;
      if (finalValue !== "" && finalValue != null || finalUnit !== "" && finalUnit != null || finalUnitType !== "" && finalUnitType != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTextChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customText" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      unit,
      unitType,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value != null && value !== "") ||
      (unit != null && unit !== "") ||
      (unitType != null && unitType !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleDateChange = (fieldId, typeOrObject, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      let updatedItem = {
        ...existing,
        fieldId,
        type: "date",
      };
      if (typeof typeOrObject === 'object') {
        updatedItem = {
          ...updatedItem,
          ...typeOrObject,
        };
      } else {
        updatedItem[typeOrObject] = newValue;
      }
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const { day, month, year } = updatedItem;
      if (
        (day !== "" && day != null) ||
        (month !== "" && month != null) ||
        (year !== "" && year != null)
      ) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomDateChange = (fieldId, typeOrObject, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customDate" };
    }

    if (typeof typeOrObject === 'object') {
      tempFieldCache[fieldId] = {
        ...tempFieldCache[fieldId],
        ...typeOrObject,
      };
    } else {
      tempFieldCache[fieldId][typeOrObject] = newValue;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      day,
      month,
      year,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (day != null && day !== "") ||
      (month != null && month !== "") ||
      (year != null && year !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTimeChange = (fieldId, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "time",
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalHour = type === "hour" ? newValue : updatedItem.hour;
      const finalMinute = type === "minute" ? newValue : updatedItem.minute;
      const finalSecond = type === "second" ? newValue : updatedItem.second;
      const finalFormat = type === "format" ? newValue : updatedItem.format;
      if (finalHour !== "" && finalHour != null || finalMinute !== "" && finalMinute != null || finalSecond !== "" && finalSecond != null || finalFormat !== "" && finalFormat != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleCustomTimeChange = (fieldId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = totalDataEntry.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...existing, fieldId, type: "customTime" };
    }

    tempFieldCache[fieldId][type] = newValue;

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      hour,
      minute,
      second,
      format,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (hour != null && hour !== "") ||
      (minute != null && minute !== "") ||
      (second != null && second !== "") ||
      (format != null && format !== "") ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    setTotalDataEntry(prev => {
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (hasAnyValue) {
        filtered.push(tempFieldCache[fieldId]);
      }
      return filtered;
    });
  };

  const handleTextareaChange = (fieldId, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: "textarea",
        value: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      if (newValue !== "" && newValue != null) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const handleRangeScoreChange = (fieldId, fieldType, type, newValue) => {
    setTotalDataEntry(prev => {
      const existing = prev.find(item => item.fieldId === fieldId) || {};
      const updatedItem = {
        ...existing,
        fieldId,
        type: fieldType,
        [type]: newValue,
      };
      const filtered = prev.filter(item => item.fieldId !== fieldId);
      const finalValue = type === "value" ? newValue : updatedItem.value;
      const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
      if ((finalValue !== "" && finalValue != null) ||
        (finalValueRemark !== "" && finalValueRemark != null)) {
        filtered.push(updatedItem);
      }
      return filtered;
    });
  };

  const checkConditionalFunction = (fieldId, optionId) => {
    let checkFieldConditionalId = [...new Set(formFields?.filter(item => item.id === fieldId)?.map(item => item.conditionalFields).filter(Boolean).flat())]
    let conditionalOptionId = checkFieldConditionalId.filter(item => item.includes(optionId));
    let conditionalFieldId = conditionalOptionId?.map(id => Number(id.split('_')[0]))
    if (conditionalFieldId?.length > 0) {
      return totalDataEntry?.filter(item => !conditionalFieldId?.includes(item.fieldId))
    } else {
      return [...totalDataEntry]
    }
  }

  const handleDropdownRadioChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "dropdownRadio",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleScaleChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "scale",
      [type]: newValue,
    };
    if (type === "value") {
      updatedItem.id = optionId
    }
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleUploadChange = async (fieldId, type, newValue) => {
    let uploadedFile
    const formData = new FormData();
    if (type === "value") {
      formData.append("file", newValue);
      uploadedFile = await studySiteDataEntryServices.uploadDocumentData(formData);
    }
    const existing = totalDataEntry?.find(item => item.fieldId === fieldId) || {};
    const updatedItem = {
      ...existing,
      fieldId,
      type: "file",
      value: type === "value" ? (uploadedFile?.data || "") : existing?.value || "",
      valueRemark: type === "valueRemark" ? newValue : existing?.valueRemark || "",
    };
    const filtered = totalDataEntry.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? newValue : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if ((finalValue !== "" && finalValue != null) ||
      (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomDropdownRadioChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const base = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {};
      tempFieldCache[fieldId] = { ...base };
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customDropdownRadio",
      [type]: newValue,
    };

    if (type === "value") {
      tempFieldCache[fieldId].id = optionId;
    }

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (value !== "" && value != null) ||
      (referenceRangeLowerLimit !== "" && referenceRangeLowerLimit != null) ||
      (referenceRangeLowerLimitEntryType !== "" && referenceRangeLowerLimitEntryType != null) ||
      (referenceRangeUpperLimit !== "" && referenceRangeUpperLimit != null) ||
      (referenceRangeUpperLimitEntryType !== "" && referenceRangeUpperLimitEntryType != null) ||
      (referenceRangeIndicator !== "" && referenceRangeIndicator != null) ||
      (clinicalSignificance !== "" && clinicalSignificance != null) ||
      (remark !== "" && remark != null);

    let finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  const handleCheckboxChange = (fieldId, optionId, type, newValue) => {
    let finalDataEntry = checkConditionalFunction(fieldId, optionId)
    const existing = finalDataEntry?.find(item => item.fieldId === fieldId) || { fieldId, value: [] };
    const updatedValueArray = Array.isArray(existing.value) ? [...existing.value] : [];
    const existingIndex = updatedValueArray.findIndex(
      item => item.id === optionId && item.value === newValue
    );
    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }
    const updatedItem = {
      ...existing,
      fieldId,
      type: "checkbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId);
    const finalValue = type === "value" ? updatedValueArray : updatedItem.value;
    const finalValueRemark = type === "valueRemark" ? newValue : updatedItem.valueRemark;
    if (finalValue.length > 0 || (finalValueRemark !== "" && finalValueRemark != null)) {
      filtered.push(updatedItem);
    }
    setTotalDataEntry(filtered)
  };

  const handleCustomCheckboxChange = (fieldId, optionId, type, newValue, disable) => {
    if (!tempFieldCache[fieldId]) {
      const existing = checkConditionalFunction(fieldId, optionId)?.find(item => item.fieldId === fieldId) || {
        fieldId,
        value: [],
      };
      tempFieldCache[fieldId] = { ...existing };
    }

    const updatedValueArray = Array.isArray(tempFieldCache[fieldId].value)
      ? [...tempFieldCache[fieldId].value]
      : [];

    const existingIndex = updatedValueArray.findIndex(
      (item) => item.id === optionId && item.value === newValue
    );

    if (existingIndex > -1) {
      updatedValueArray.splice(existingIndex, 1);
    } else {
      updatedValueArray.push({ id: optionId, value: newValue });
    }

    tempFieldCache[fieldId] = {
      ...tempFieldCache[fieldId],
      fieldId,
      type: "customCheckbox",
      [type]: type === "value" ? updatedValueArray : newValue,
    };

    if (disable === "yes") {
      tempFieldCache[fieldId]["clinicalSignificance"] = ""
    }

    const {
      value,
      referenceRangeLowerLimit,
      referenceRangeLowerLimitEntryType,
      referenceRangeUpperLimit,
      referenceRangeUpperLimitEntryType,
      referenceRangeIndicator,
      clinicalSignificance,
      remark,
    } = tempFieldCache[fieldId];

    const hasAnyValue =
      (Array.isArray(value) && value.length > 0) ||
      (referenceRangeLowerLimit != null && referenceRangeLowerLimit !== "") ||
      (referenceRangeLowerLimitEntryType != null && referenceRangeLowerLimitEntryType !== "") ||
      (referenceRangeUpperLimit != null && referenceRangeUpperLimit !== "") ||
      (referenceRangeUpperLimitEntryType != null && referenceRangeUpperLimitEntryType !== "") ||
      (referenceRangeIndicator != null && referenceRangeIndicator !== "") ||
      (clinicalSignificance != null && clinicalSignificance !== "") ||
      (remark != null && remark !== "");

    const finalDataEntry = checkConditionalFunction(fieldId, optionId);
    const filtered = finalDataEntry?.filter(item => item.fieldId !== fieldId) || [];

    if (hasAnyValue) {
      filtered.push(tempFieldCache[fieldId]);
    }

    setTotalDataEntry(filtered);
  };

  function convertTo24(timeStr) {
    const [time, modifier = "AM"] = timeStr.split(" ");
    let [hours, minutes, seconds] = time.split(":");

    hours = parseInt(hours, 10);
    if (modifier === "PM" && hours !== 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes}:${seconds}`;
  }
  const [openAction, setOpenAction] = useState(false)

  const handleCheckboxEditFieldChange = (fieldId, isChecked) => {
    setEditField((prev) => {
      if (isChecked) {
        return [...prev, fieldId];
      } else {
        return prev.filter((id) => id !== fieldId);
      }
    });
  };

  const firstLine = fieldLabel?.split('\n')[0]?.replace(/<[^>]*>?/gm, '').substring(0, 50) || '';

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 144px)" }}>
        {loading ? (
          <PageLoader />
        ) : formMetadataList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Event schema form list not found!"} />
          </div>
        ) : (
          <ListGroup className="p-2 br3">
            {formMetadataList.map((metadata, index) => (
              metadata?.formType === "regular" ? (
                <ListGroup.Item action
                  title={metadata?.formLabel}
                  onClick={() => {
                    setFormId(metadata?.formId);
                    setOriginalFormId(metadata?.originalFormId || "");
                    setFormName(metadata?.formLabel);
                    setFormRepeat(metadata?.formRepeat);
                    setRepeatNumber(metadata?.repeat);
                    setFormType(metadata?.formType);
                    setEntryType(metadata?.type);
                    setVersion(metadata?.version || "1")
                    setLoadForm(true)
                  }}
                  key={index}
                  className={`hstack p-0 ${formId === metadata?.formId && "selectedMenu"}`}
                >
                  <div className="hstack justify-content-between w-100 pe-2">

                    <div className="hstack gap-2">
                      <div className={metadata?.checkDataEntry === "query" ? "bg-danger" : metadata?.checkDataEntry === "queryNotify" ? "bg-purple-subtle" : metadata?.checkDataEntry === "entry" ? "bg-warning" : metadata?.checkDataEntry === "reviewed" ? "bg-success" : "bg-primary-subtle"} style={{ minWidth: 8, minHeight: "100%", backgroundColor: "#c7d3dd" }}></div>
                      <span style={{ fontSize: 12, padding: 7 }}>{metadata?.formLabel}</span>
                    </div>
                    {metadata?.repeat > 0 &&
                      <Badge bg="primary-subtle" className="br3 text-dark mt-1" style={{ fontSize: 9 }}>R{metadata?.repeat}</Badge>
                    }
                    {activeTabName?.viewType === "noEntry" &&
                      <Badge bg="primary-subtle" className="br3 text-dark mt-1" style={{ fontSize: 9 }}>V{metadata?.version}</Badge>
                    }
                  </div>
                </ListGroup.Item>
              ) : (
                <>
                  <ListGroup.Item action
                    title={metadata?.formLabel}
                    onClick={() => {
                      if (openAction === metadata?.formId) {
                        setOpenAction("")
                        setFormFields([])
                        setLoadForm(false)
                      } else {
                        setOpenAction(metadata?.formId);
                        setFormId(metadata?.formId);
                        setOriginalFormId(metadata?.originalFormId || "");
                        setFormName(metadata?.formLabel);
                        setFormType(metadata?.formType);
                        setEntryType(metadata?.type);
                        setVersion(metadata?.version || "1")
                        setRecordId("")
                        setRecordNumber("")
                        setLoadForm(false)
                      }
                    }}
                    key={index}
                    style={{ padding: 7 }}
                    className={`hstack position-relative ${formId === metadata?.formId && "selectedMenu"}`}
                  >
                    <div className="hstack justify-content-between w-100">
                      <span style={{ fontSize: 12 }}>{metadata?.formLabel}</span>
                      {!logRecordLoader ? (metadata?.formId === openAction ? <IoMdArrowDropup /> : <IoMdArrowDropdown />) : ""}
                    </div>
                  </ListGroup.Item>
                  <Collapse in={openAction === metadata?.formId}>
                    <div>
                      {!logRecordLoader &&
                        <>
                          <ListGroup.Item
                            action style={{ fontSize: 12, width: "-webkit-fill-available" }}
                            title='Add New Record'
                            className={recordId ? '' : loadForm ? "bg-primary-subtle" : ""}
                            onClick={() => {
                              setFormId(metadata?.formId);
                              setOriginalFormId(metadata?.originalFormId || "");
                              setFormName(metadata?.formLabel);
                              setFormType(metadata?.formType);
                              setEntryType(metadata?.type);
                              setVersion(metadata?.version || "1")
                              setRecordId("");
                              setRecordNumber("")
                              setLoadForm(true)
                            }}
                          >
                            <FaRegPlusSquare className="mb-1" /> Add New Record
                          </ListGroup.Item>
                          {logRecord?.map(((item, index) => (
                            <ListGroup.Item
                              onClick={() => {
                                setFormId(metadata?.formId);
                                setOriginalFormId(metadata?.originalFormId || "");
                                setFormName(metadata?.formLabel);
                                setFormType(metadata?.formType);
                                setEntryType(metadata?.type);
                                setRecordId(item?.recordId);
                                setVersion(metadata?.version || "1")
                                setRecordNumber(index + 1)
                                setLoadForm(true)
                              }}
                              action
                              title={`Record ${index + 1}`}
                              className={recordId === item?.recordId ?
                                item?.checkDataEntry === "query" ? "bg-danger text-white" : item?.checkDataEntry === "queryNotify" ? "bg-purple text-white" : item?.checkDataEntry === "reviewed" ? "bg-success text-white " : "bg-warning text-white"
                                :
                                item?.checkDataEntry === "query" ? "bg-danger-subtle" : item?.checkDataEntry === "queryNotify" ? "bg-purple-subtle" : item?.checkDataEntry === "reviewed" ? "bg-success-subtle " : "bg-warning-subtle"
                              }
                              style={{ fontSize: 12, backgroundColor: "#c7d3dd" }}
                            >
                              <GoChecklist className="mb-1" /> Record {index + 1}
                            </ListGroup.Item>
                          )))}
                        </>
                      }
                    </div>
                  </Collapse>
                </>
              )))}
          </ListGroup>
        )}
        {!formId ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Select any form."} />
          </div>
        ) : (fieldLoading || dataEntryLoader) ? (
          <div className="hstack justify-content-center h-100">
            <img src={Loader} alt="" />
          </div>
        ) : formFields.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Not any filed."} />
          </div>
        ) : (
          <FormDataEntryReport
            formName={formName}
            recordNumber={recordNumber}
            StudyMode={StudyMode}
            studyPermission={studyPermission}
            activeTabName={activeTabName}
            formRepeat={formRepeat}
            repeatNumber={repeatNumber}
            totalDataEntry={totalDataEntry}
            repeatButtonLoader={repeatButtonLoader}
            repeatStudySubjectEventForm={repeatStudySubjectEventForm}
            saveButtonLoader={saveButtonLoader}
            addNewStudySubjectDataEntry={addNewStudySubjectDataEntry}
            setToggle4={setToggle4}
            formFields={formFields}
            totalOptionId={totalOptionId}
            valueRanderFunction={valueRanderFunction}
            handleNumberChange={handleNumberChange}
            handleCustomNumberChange={handleCustomNumberChange}
            handleTextChange={handleTextChange}
            handleCustomTextChange={handleCustomTextChange}
            handleDateChange={handleDateChange}
            handleCustomDateChange={handleCustomDateChange}
            handleTimeChange={handleTimeChange}
            handleCustomTimeChange={handleCustomTimeChange}
            handleTextareaChange={handleTextareaChange}
            handleDropdownRadioChange={handleDropdownRadioChange}
            handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
            handleRangeScoreChange={handleRangeScoreChange}
            handleScaleChange={handleScaleChange}
            handleUploadChange={handleUploadChange}
            handleCheckboxChange={handleCheckboxChange}
            handleCustomCheckboxChange={handleCustomCheckboxChange}
            convertTo24={convertTo24}
            getStudySubjectFormFieldQueryHistoryDataEntry={getStudySubjectFormFieldQueryHistoryDataEntry}
            getStudySubjectFormFieldQueryNotificationDataEntry={getStudySubjectFormFieldQueryNotificationDataEntry}
            getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
            getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
            getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
            dataEntryFormReviewHistory={dataEntryFormReviewHistory}
            dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
            formId={formId}
            version={version}
            setToggle6={setToggle6}
            setToggle7={setToggle7}
            getStudySubjectFormReviewHistoryDataEntry={getStudySubjectFormReviewHistoryDataEntry}
            handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
            editField={editField}
          />
        )}
      </SplitPane>
      <FreezeUnfreezeHistory
        Show={!toggle}
        Hide={setToggle}
        Title={`${firstLine} (Freeze and Unfreeze History)`}
        freezeUnfreezeHistory={freezeUnfreezeHistory}
        tableRef={tableRef}
        freezeLoader={freezeLoader}
        onMouseDown={onMouseDown}
        remark={remark}
        setRemark={setRemark}
        fieldId={fieldId}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        unfreezeButtonLoader={unfreezeButtonLoader}
        unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry={unfreezeStudySubjectFormFreezeUnfreezeHistoryDataEntry}
      />
      <SignatureReviewHistory
        Show={!toggle1}
        Hide={setToggle1}
        Title={`${firstLine} (Review History)`}
        fieldLabel={fieldLabel}
        dataEntryReviewHistory={dataEntryReviewHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        remark={remark}
        setRemark={setRemark}
        fieldId={fieldId}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        signedButtonLoader={signedButtonLoader}
        signatureStudySubjectFormReviewFieldHistoryDataEntry={signatureStudySubjectFormReviewFieldHistoryDataEntry}
      />
      <SignatureReviewAllField
        Show={!toggle4}
        Hide={setToggle4}
        Title={`${formName} (SDV All Field)`}
        remark={remark}
        setRemark={setRemark}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedFields={setSelectedFields}
        selectedFields={selectedFields}
        totalOptionId={totalOptionId}
        signedAllButtonLoader={signedAllButtonLoader}
        signatureStudySubjectFormReviewAllFieldDataEntry={signatureStudySubjectFormReviewAllFieldDataEntry}
      />
      <FieldQueryHistory
        Show={!toggle3}
        Hide={setToggle3}
        Title={`${firstLine} (Query History)`}
        fieldLabel={fieldLabel}
        dataEntryQueryHistory={dataEntryQueryHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        querySubject={querySubject}
        setQuerySubject={setQuerySubject}
        queryMessage={queryMessage}
        setQueryMessage={setQueryMessage}
        reasonMessage={reasonMessage}
        setReasonMessage={setReasonMessage}
        fieldId={fieldId}
        formFields={formFields}
        totalDataEntry={totalDataEntry}
        setSelectedRadioField={setSelectedRadioField}
        selectedRadioField={selectedRadioField}
        dataEntryQueryDiscussion={dataEntryQueryDiscussion}
        setResponseMessage={setResponseMessage}
        responseMessage={responseMessage}
        queryButtonLoader={queryButtonLoader}
        genarateButtonLoader={genarateButtonLoader}
        queryDataLoader={queryDataLoader}
        queryDiscussionStudySubjectFormField={queryDiscussionStudySubjectFormField}
        generateManualQueryStatusStudySubjectFormField={generateManualQueryStatusStudySubjectFormField}
        getStudySubjectFormFieldQueryDiscussionDataEntry={getStudySubjectFormFieldQueryDiscussionDataEntry}
        generateManualQueryStudySubjectFormFieldDataEntry={generateManualQueryStudySubjectFormFieldDataEntry}
      />
      <FieldErrorNotification
        Show={!toggle5}
        Hide={setToggle5}
        Title={`${firstLine} (Error Notification)`}
        dataEntryQueryNotification={dataEntryQueryNotification}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        generateQueryNotificationStatusStudySubjectFormField={generateQueryNotificationStatusStudySubjectFormField}
      />
      <FieldUpdatedHistory
        Show={!toggle2}
        Hide={setToggle2}
        Title={`${firstLine} (Updated History)`}
        updatedFieldHistory={updatedFieldHistory}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        fieldId={fieldId}
        formFields={formFields}
        historyLoader={historyLoader}
      />
      <ReviewFormDataEntry
        Show={!toggle6}
        Hide={setToggle6}
        signButtonLoader={signButtonLoader}
        signatureStudySubjectFormReviewHistoryDataEntry={signatureStudySubjectFormReviewHistoryDataEntry}
        Title={`${formName}`}
        setUserId={setUserId}
        userId={userId}
        setPassword={setPassword}
        password={password}
      />
    </>
  );
};

export default FormDataEntry;
